import { render, staticRenderFns } from "./detailMainPage.vue?vue&type=template&id=2e30f442&scoped=true"
import script from "./detailMainPage.vue?vue&type=script&lang=js"
export * from "./detailMainPage.vue?vue&type=script&lang=js"
import style0 from "./detailMainPage.vue?vue&type=style&index=0&id=2e30f442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30f442",
  null
  
)

export default component.exports